module.exports = __webpack_public_path__ + "img/banner-1-m.fd45e62d.jpg";